import { parseTemplate } from 'url-template';
import { formatApiDate } from '~/Api/DateTime';
import { ErrorResponse } from '~/Api/User/ProductGroup/RoMaxPrice/ErrorResponse';
import { mapRoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice/mapRoMaxPrice';
import { RoMaxPrice } from '~/Api/User/ProductGroup/RoMaxPrice/RoMaxPrice';
import { Update } from '~/Api/User/ProductGroup/RoMaxPrice/Update';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

export interface Result {
	roMaxPrice: RoMaxPrice;
}

export const updateRoMaxPrice = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	update: Update
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ro-max-price');

	try {
		const request = await client.fetch(url.expand({ userId, groupId }), {
			body: JSON.stringify({
				products: update.products.map((product) => ({
					id: product.id,
					packageSizeForCalculation: product.packageSizeForCalculation,
					packageSizeForSingleUnit: product.packageSizeForSingleUnit,
					priceTypeForCalculation: product.priceTypeForCalculation,
					selected: product.selected,
				})),
				reference: {
					decisionNumber: update.decisionNumber,
					packageSize: update.packageSize,
					referenceBasketVersion: update.referenceBasketVersion,
					historicProductDataViewDate:
						update.historicProductDataViewDate !== null ? formatApiDate(update.historicProductDataViewDate) : null,
					referencedProductType: update.referencedProductType,
					fxUpdatePrice: update.fxUpdatePrice,
					fxUpdatePriceEnabled: update.fxUpdatePriceEnabled,
					prgPrbPrice: update.prgPrbPrice,
					prgPrbPriceEnabled: update.prgPrbPriceEnabled,
					priPrice: update.priPrice,
					priPriceEnabled: update.priPriceEnabled,
					lossOfExclusivity: update.lossOfExclusivity,
					gtin: update.gtin,
				},
			}),
			method: 'POST',
		});
		const response = await request.json();
		return {
			roMaxPrice: mapRoMaxPrice(response.roMaxPrice),
		};
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
};
